import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserGroupAclStoreActions, UserGroupAclStoreSelectors } from '@era/stores';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NamedUserGroupAcl, isNotUndefined } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { GroupPermissionsEntityListComponent } from './group-permissions-entity-list.component';

@Component({
  selector: 'era-groups-permissions-entity-list',
  templateUrl: './groups-permissions-entity-list.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GroupPermissionsEntityListComponent, AsyncPipe],
})
export class GroupsPermissionsEntityListContainerComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public readonly acl$: Observable<NamedUserGroupAcl>;
  public readonly error$: Observable<string>;

  constructor() {
    this.acl$ = this.store
      .select(UserGroupAclStoreSelectors.selectUserGroupAclByResourceWithName('Default-Group'))
      .pipe(filter(isNotUndefined));
    this.error$ = this.actions$
      .pipe(ofType(UserGroupAclStoreActions.AccessControlListApiActions.userGroupAclLoadedError))
      .pipe(map(() => 'An unknown error has occurred.'));
  }
}
